import { useCallback, useEffect } from 'react';
import { info } from '@helpers/logger';

export const useAncestorLogger = (ref: React.RefObject<HTMLElement>, message: string, condition: boolean) => {
    const getAncestorClasses = useCallback(() => {
        if (ref?.current === undefined) { return []; }

        let ancestorClasses: string[] = [];

        for (let element = ref.current; element?.parentElement; element = element?.parentElement) {
            ancestorClasses = [...ancestorClasses, element?.className ?? ''];
        }

        return ancestorClasses;
    }, [ref]);

    useEffect(() => {
        if (condition) {
            const ancestorClasses = getAncestorClasses();

            info(message, { ancestorClasses });
        }
    }, [condition, getAncestorClasses, message]);
};
